import React, { FC } from 'react';
import _ from 'lodash';
import { useIntl } from 'react-intl';
import { Button } from 'react-bootstrap';
import { Actions, Rule, Target } from '../../../../../models/form/rule';
import { FieldType } from '../../../../../models/form/fieldType';
import { RulesTemplates } from './RulesTemplates';
import { FieldTransformed } from './Rules';
import SelectInput from '../../../../../components/library/inputs/select/SelectInput';
import { FieldModel } from '../../../../../models/form/field';

interface Props {
  renderFieldOptions: (predicate: (field: FieldModel) => boolean, renderAllFields: boolean) => React.ReactNode;
  setRule: (rule: Rule) => void;
  getField: (fieldId: string) => FieldTransformed | undefined;
  rule: Rule;
  createNewTarget: () => Target;
}

const Targets: FC<Props> = ({ renderFieldOptions, rule, setRule, getField, createNewTarget }: Props) => {
  const intl = useIntl();

  const removeTarget = (targetId: string) => {
    const ruleTemp = { ...rule };
    _.remove(ruleTemp.targets, { id: targetId });
    setRule(ruleTemp);
  };

  const addTarget = (rule: Rule) => {
    const ruleTemp = { ...rule };
    ruleTemp.targets.push(createNewTarget());
    setRule(ruleTemp);
  };

  const renderPossibleActions = (fieldType: FieldType | undefined, action: Actions, targetIndex: number) => {
    if (!fieldType) {
      return null;
    }
    return (
      <SelectInput
        noEmptyValue
        size="sm"
        value={action}
        onChange={(e) => {
          const ruleTemp = { ...rule };
          ruleTemp.targets[targetIndex].action = e.target.value as Actions;
          setRule(ruleTemp);
        }}
        options={RulesTemplates[fieldType].actions.map((theAction) => {
          return {
            value: theAction,
            text: intl.formatMessage({ id: theAction }),
          };
        })}
        style={{ height: 38 }}
      />
    );
  };

  const renderFieldSelectTarget = (rule: Rule, fieldId: string, targetIndex: number) => {
    return (
      <SelectInput
        noEmptyValue
        size="sm"
        value={fieldId}
        onChange={(e) => {
          const ruleTemp = { ...rule };
          ruleTemp.targets[targetIndex].fieldId = e.target.value;
          setRule(ruleTemp);
        }}
        customOptions={renderFieldOptions(() => true, false)}
        style={{ height: 38 }}
      />
    );
  };

  return (
    <div>
      {rule.targets.map((target, targetIndex) => {
        return (
          <div className="d-flex pb-3" key={'target' + targetIndex}>
            <div style={{ marginRight: 8 }}>
              <Button size="sm" variant="danger" onClick={() => removeTarget(target.id)}>
                &times;
              </Button>
            </div>
            <div style={{ flex: 1, paddingRight: 8 }}>{renderFieldSelectTarget(rule, target.fieldId, targetIndex)}</div>
            <div style={{ flex: 1, paddingRight: 8 }}>
              {renderPossibleActions(getField(target.fieldId)?.type, target.action, targetIndex)}
            </div>
          </div>
        );
      })}
      <div>
        <Button variant="light" className="w-100" onClick={() => addTarget(rule)}>
          {intl.formatMessage({ id: 'rulesAdmin.general.addNewTarget' })}
        </Button>
      </div>
    </div>
  );
};

export default Targets;
